import React, {Fragment} from "react";
import {Button, Col, Collapse, Descriptions, Popconfirm, Row, Space, Tag, Typography} from "antd";
import {AlertOutlined} from "@ant-design/icons";
import moment from "moment";
import {HDate} from "@hebcal/core";
import Hebcal from "../../../../hebcal";
import ModalAdresseOpenWith from "../../../../modals/ModalAdresseOpenWith";
import ModalEditRoute from "../maps/ModalEditRoute";
import ModalAnniv from "../ModalAnniv";

const {Text, Title} = Typography

export class FicheInfos extends React.Component {

    getAge(date) {
        var today = new Date();
        var birthDate = new Date(date);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }

    getHebddn(ddn) {
        let org = null
        try {
            org = JSON.parse(localStorage.getItem("ORG"))
        } catch (e) {
        }

        var hdate = new HDate(new Date(ddn))
        if (org) {
            const hebcal = new Hebcal(org, new Date(), org.lat, org.long)
            hdate = hebcal.getAnnivHDate(new Date(ddn))
            console.log(hdate.toLocaleString())
        }
        return hdate.getDate() + "/" + hdate.getMonthName() + "/" + hdate.getFullYear()
    }


    formatFieldValue(field) {
        if (field.type === "DATE") {
            return new Date(field.value).toLocaleDateString()
        }

        if (field.type === "DATETIME") {
            var date = new Date(field.value)
            return date.toLocaleDateString() + " à " + date.toLocaleTimeString()
        }

        return field.value
    }

    adresseOpenWith() {
        const {selected} = this.props

        const query = selected.adresse + " " + selected.postal + " " + selected.ville + " " + (selected.pays || "France")

        this.modalAdresseOpenWith.show(query, this.modalAdresseOpenWith.getContactAdresseLatLong(selected, query))
    }

    render() {
        const {selected, fiche} = this.props

        if (!selected) {
            return null
        }

        return (
            <Fragment>
                <Collapse defaultActiveKey={["mainInfo","deceasedInfo"]} bordered={false}>
                    <Collapse.Panel key={"mainInfo"} header={"Informations Principales"}>
                        <p>Formalité: {selected.formalite}</p>
                        <p>Description: {selected.description}</p>

                        {selected.parents.length === 0 && selected.adresse && (
                            <Col style={{marginTop: 10, marginBottom: 30}}>
                                <Space>
                                    <Text>
                                        <Text strong>Adresse : </Text>
                                        <a onClick={() => this.adresseOpenWith()}>
                                            {selected.adresse} - {selected.postal} {selected.ville} {selected.pays}
                                        </a>
                                    </Text>
                                    {selected.route && (
                                        <Tag style={{cursor: "pointer"}}
                                             onClick={() => this.modalEditRoute.show(selected.id, "MAIN", selected.route)}
                                             color={"geekblue"}>{selected.route}</Tag>
                                    )}
                                </Space>
                                {selected.note_adresse && (
                                    <Col>
                                        <Text type="secondary"><Text strong>Complement Adresse
                                            : </Text> {selected.note_adresse}</Text>
                                    </Col>
                                )}
                            </Col>
                        )}

                        <Descriptions layout="vertical" size={"small"} bordered>
                            <Descriptions.Item label="Nom">{selected.nom}</Descriptions.Item>
                            <Descriptions.Item label="Prénom">{selected.prenom}</Descriptions.Item>
                            {selected.homme !== null && selected.homme !== undefined && (<Descriptions.Item
                                label="Homme/Femme">{selected.homme ? "Homme" : "Femme"}</Descriptions.Item>)}
                            {selected.ddn && (<Descriptions.Item
                                label="Date de Naissance"> <Button type={"link"} icon={<AlertOutlined/>} onClick={()=>this.modalAnniv.show(selected.id,selected?.rappelAnniv)}/> {moment(selected.ddn).format("DD/MM/YYYY") + " - " + this.getHebddn(selected.ddn)}</Descriptions.Item>)}
                            {selected.ddn && (<Descriptions.Item
                                label="Age">{this.getAge(selected.ddn)} ans</Descriptions.Item>)}
                        </Descriptions>

                    </Collapse.Panel>


                    {selected.deceased && (
                        <Collapse.Panel key={"deceasedInfo"}
                                        header={"Informations du Décés"}>
                            <Row style={{marginTop: 20}}>
                                <Descriptions layout="vertical" size={"small"} bordered>
                                    {selected.deceasedDate && (
                                        <Descriptions.Item label="Date du Décés">  {moment(selected.deceasedDate).format("DD/MM/YYYY") + " - " + this.getHebddn(selected.deceasedDate)}</Descriptions.Item>
                                    )}
                                    {selected.prenomHE && (
                                        <Descriptions.Item label="Prénom Hébraique">{selected.prenomHE}</Descriptions.Item>
                                    )}
                                    {selected.deceasedPere && (
                                        <Descriptions.Item label="Prénom du Pere">{selected.deceasedPere}</Descriptions.Item>
                                    )}
                                    {selected.deceasedMere && (
                                        <Descriptions.Item label="Prénom de la Mere">{selected.deceasedMere}</Descriptions.Item>
                                    )}
                                    {selected.deceasedLocation && (
                                        <Descriptions.Item label="Lieu de l'enterrement">{selected.deceasedLocation}</Descriptions.Item>
                                    )}

                                </Descriptions>
                            </Row>
                        </Collapse.Panel>
                    )}

                    {selected.fields.length > 0 && (
                        <Collapse.Panel key={"secondaryInfo"}
                                        header={"Informations Secondaires (" + selected.fields.length + ")"}>
                            <Row style={{marginTop: 20}}>
                                {
                                    selected.fields.map((item, index) => {
                                        return (
                                            <div key={index} style={{
                                                marginRight: 30,
                                                marginTop: 10,
                                                cursor: "pointer"
                                            }}>
                                                <Popconfirm
                                                    title="Êtes-vous sûrs de vouloir supprimer cette information ?"
                                                    onConfirm={() => fiche.onDelete(item.id, "field")}
                                                    okText="Oui"
                                                    cancelText="Non"
                                                    okType={"danger"}
                                                >
                                                    <Text underline
                                                          strong>{item.key}</Text> : {this.formatFieldValue(item)}
                                                </Popconfirm>
                                            </div>
                                        )
                                    })
                                }
                            </Row>
                        </Collapse.Panel>
                    )}
                </Collapse>
                <ModalAnniv getRef={ref => this.modalAnniv = ref} onFinish={() => fiche.getData()}/>
                <ModalAdresseOpenWith getRef={ref => this.modalAdresseOpenWith = ref}/>
                <ModalEditRoute getRef={ref => this.modalEditRoute = ref} onFinish={() => fiche.getData()}/>
            </Fragment>
        )
    }
}
